import { DigitalIcon } from "@lhd/assets";
import { Styles } from "./styled";
import { useMemo } from "react";
import { calculateTotalWorkingMs, sortLogsByLoggedAt } from "../until";
import { LOG_TYPE } from "../contants";
import { CurrentTimeInfo, WorkerLogtimeData } from "@lhd/types";

type CurrentTimeQueryData = {
  data?: CurrentTimeInfo;
  datetimeWithTimeRes?: Date;
};

interface IProps {
  className?: string;
  currentTimeData?: CurrentTimeQueryData;
  workerLogtimesData?: WorkerLogtimeData;
  serverNowMs?: number;
}

const DigitalClock = (props: IProps) => {
  const { className, currentTimeData, workerLogtimesData, serverNowMs } = props;

  const normalizeYmd = (value?: string) => {
    const t = value?.trim();
    return t ? t.replace(/\//g, "-") : "";
  };

  const currentWorkDate = normalizeYmd(currentTimeData?.data?.current_date);
  const todayLogs = useMemo(() => {
    const logs = workerLogtimesData?.today_logs || [];
    const filtered = currentWorkDate
      ? logs.filter((log) => normalizeYmd(log.work_date) === currentWorkDate)
      : logs;
    return sortLogsByLoggedAt(filtered);
  }, [currentWorkDate, workerLogtimesData?.today_logs]);

  const lastLog = todayLogs.at(-1);

  const dataTime = useMemo(() => {
    if (!todayLogs.length) {
      return { time: 0 };
    }

    const isWorking =
      lastLog?.log_type === LOG_TYPE.CHECKIN ||
      lastLog?.log_type === LOG_TYPE.BREAK_END;

    const timeMs = calculateTotalWorkingMs(
      todayLogs,
      isWorking ? serverNowMs ?? Date.now() : undefined,
    );

    return { time: timeMs };
  }, [lastLog?.log_type, serverNowMs, todayLogs]);

  function msToHHMMSS(ms: number): string {
    const totalSeconds = Math.floor(ms / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const hh = String(hours).padStart(2, "0");
    const mm = String(minutes).padStart(2, "0");
    const ss = String(seconds).padStart(2, "0");

    return `${hh}:${mm}:${ss}`;
  }

  return (
    <Styles className={className || ""}>
      <div className="wrapper-clock">
        {msToHHMMSS(dataTime.time)
          .split("")
          .map((char, index) => (
            <div key={index}>
              <DigitalIcon
                numberString={char}
                colorActive="var(--color-active)"
                colorUnActive="var(--color-un_active)"
              />
            </div>
          ))}
      </div>
    </Styles>
  );
};

export default DigitalClock;
